import { z } from 'zod';
import { TextItem } from './common';
export var MoodPlanStrategy = TextItem;
export var MoodPlanMoodEnum = {
    SAD: 'SAD',
    STRESSED: 'STRESSED',
    GUILTY: 'GUILTY',
    BORED: 'BORED',
    ANGRY: 'ANGRY',
    HAPPY: 'HAPPY'
};
export var MoodPlan = z.object({
    moods: z.array(z.object({
        mood: z.nativeEnum(MoodPlanMoodEnum),
        strategy: z.array(MoodPlanStrategy)
    }))
}).prefault({
    moods: []
});
